import { render } from "./IconAlertTriangleFill.vue?vue&type=template&id=c0ec2ef0"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconAlertTriangleFill.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0ec2ef0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0ec2ef0', __exports__)) {
    api.reload('c0ec2ef0', __exports__)
  }
  
  module.hot.accept("./IconAlertTriangleFill.vue?vue&type=template&id=c0ec2ef0", () => {
    api.rerender('c0ec2ef0', render)
  })

}


export default __exports__